/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Howtoclaim2Inputs */

const id_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Cara Mendapatkannya?`)
};

const ms_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Cara Menuntutnya?`)
};

const da_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Hvordan Indløser Man Det?`)
};

const de_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Wie man es einlöst?`)
};

const en_us2_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 How to Claim It?`)
};

const es_es2_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎀 ¿Cómo canjearlo?`)
};

const es_mx2_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎀 ¿Cómo canjearlo?`)
};

const fil_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paano Ito I-claim?`)
};

const fr_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Comment le récupérer ?`)
};

const it_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come richiederlo?`)
};

const hu_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hogyan igényelhető?`)
};

const nl_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe claim je het?`)
};

const no_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvordan løse det inn?`)
};

const pl_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Jak odebrać?`)
};

const pt_br2_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Como reivindicá-lo?`)
};

const pt_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Como resgatar?`)
};

const ro_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Cum să îl revendici?`)
};

const fi_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Miten lunastaa?`)
};

const sv_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Hur löser man in?`)
};

const vi_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Làm thế nào để nhận?`)
};

const tr_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Nasıl Alınır?`)
};

const cs_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Jak ji získat?`)
};

const bg_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Как да я вземете?`)
};

const ru_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Как получить?`)
};

const uk_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 Як отримати?`)
};

const ar_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 كيف تستلمها؟`)
};

const hi_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 कैसे प्राप्त करें?`)
};

const th_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 วิธีรับ?`)
};

const ja_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 入手方法は？`)
};

const zh_cn2_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🎁 如何领取？`)
};

const zh_hant1_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何領取？`)
};

const ko_misc_posts_howtoclaim2 = /** @type {(inputs: Misc_Posts_Howtoclaim2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`받는 방법:`)
};

/**
* | output |
* | --- |
* | "🎁 How to Claim It?" |
*
* @param {Misc_Posts_Howtoclaim2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_howtoclaim2 = /** @type {((inputs?: Misc_Posts_Howtoclaim2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Howtoclaim2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_howtoclaim2(inputs)
	if (locale === "ms") return ms_misc_posts_howtoclaim2(inputs)
	if (locale === "da") return da_misc_posts_howtoclaim2(inputs)
	if (locale === "de") return de_misc_posts_howtoclaim2(inputs)
	if (locale === "en-US") return en_us2_misc_posts_howtoclaim2(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_howtoclaim2(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_howtoclaim2(inputs)
	if (locale === "fil") return fil_misc_posts_howtoclaim2(inputs)
	if (locale === "fr") return fr_misc_posts_howtoclaim2(inputs)
	if (locale === "it") return it_misc_posts_howtoclaim2(inputs)
	if (locale === "hu") return hu_misc_posts_howtoclaim2(inputs)
	if (locale === "nl") return nl_misc_posts_howtoclaim2(inputs)
	if (locale === "no") return no_misc_posts_howtoclaim2(inputs)
	if (locale === "pl") return pl_misc_posts_howtoclaim2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_howtoclaim2(inputs)
	if (locale === "pt") return pt_misc_posts_howtoclaim2(inputs)
	if (locale === "ro") return ro_misc_posts_howtoclaim2(inputs)
	if (locale === "fi") return fi_misc_posts_howtoclaim2(inputs)
	if (locale === "sv") return sv_misc_posts_howtoclaim2(inputs)
	if (locale === "vi") return vi_misc_posts_howtoclaim2(inputs)
	if (locale === "tr") return tr_misc_posts_howtoclaim2(inputs)
	if (locale === "cs") return cs_misc_posts_howtoclaim2(inputs)
	if (locale === "bg") return bg_misc_posts_howtoclaim2(inputs)
	if (locale === "ru") return ru_misc_posts_howtoclaim2(inputs)
	if (locale === "uk") return uk_misc_posts_howtoclaim2(inputs)
	if (locale === "ar") return ar_misc_posts_howtoclaim2(inputs)
	if (locale === "hi") return hi_misc_posts_howtoclaim2(inputs)
	if (locale === "th") return th_misc_posts_howtoclaim2(inputs)
	if (locale === "ja") return ja_misc_posts_howtoclaim2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_howtoclaim2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_howtoclaim2(inputs)
	return ko_misc_posts_howtoclaim2(inputs)
});
export { misc_posts_howtoclaim2 as "misc.posts.howToClaim" }